// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioLabel__container-db92a2 {
  box-sizing: border-box;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  min-width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid var(--base-60);
}

.RadioLabel__label-ea2816 {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  cursor: pointer;
}

.RadioLabel__circle-cf9959 {
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.RadioLabel__radio-e3ad16 {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
}

.RadioLabel__block-d2d9fd {
  margin-inline-start: 18px;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.RadioLabel__title-d3448d {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}

.RadioLabel__description-e42c30 {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
}

.RadioLabel__label-ea2816.RadioLabel__active-cdc748 .RadioLabel__container-db92a2 {
  border-color: var(--brand-primary-40);
}

.RadioLabel__label-ea2816.RadioLabel__active-cdc748 .RadioLabel__circle-cf9959 {
  background-color: var(--brand-primary-40);
}

.RadioLabel__label-ea2816:focus-within .RadioLabel__container-db92a2 {
  border-color: var(--brand-primary-60);
}

.RadioLabel__label-ea2816:focus-within .RadioLabel__circle-cf9959 {
  background-color: var(--brand-primary-60);
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/RadioLabel/RadioLabel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,yCAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,yCAAA;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  min-width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid var(--base-60);\n}\n\n.label {\n  margin-top: 16px;\n  display: flex;\n  flex-direction: row;\n  cursor: pointer;\n}\n\n.circle {\n  position: relative;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.radio {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n}\n\n.block {\n  margin-inline-start: 18px;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n\n.description {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n}\n\n.label.active .container {\n  border-color: var(--brand-primary-40);\n}\n\n.label.active .circle {\n  background-color: var(--brand-primary-40);\n}\n\n.label:focus-within .container {\n  border-color: var(--brand-primary-60);\n}\n\n.label:focus-within .circle {\n  background-color: var(--brand-primary-60);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RadioLabel__container-db92a2`,
	"label": `RadioLabel__label-ea2816`,
	"circle": `RadioLabel__circle-cf9959`,
	"radio": `RadioLabel__radio-e3ad16`,
	"block": `RadioLabel__block-d2d9fd`,
	"title": `RadioLabel__title-d3448d`,
	"description": `RadioLabel__description-e42c30`,
	"active": `RadioLabel__active-cdc748`
};
module.exports = ___CSS_LOADER_EXPORT___;
